window.multipleCampaigns = function() {
  return {
    init() {
      this.updateRemoveButtons()
    },

    addCampaign() {
      const container = this.$refs.container
      const items = container.querySelectorAll('[data-campaign-item]')
      const newIndex = items.length
      const template = this.createCampaignTemplate(newIndex)

      container.insertAdjacentHTML('beforeend', template)
      this.updateRemoveButtons()
    },

    removeCampaign(event) {
      const container = this.$refs.container
      const item = event.target.closest('[data-campaign-item]')
      const items = container.querySelectorAll('[data-campaign-item]')

      if (items.length > 1) {
        item.remove()
        this.updateIndexes()
        this.updateRemoveButtons()
      }
    },

    updateRemoveButtons() {
      const container = this.$refs.container
      const items = container.querySelectorAll('[data-campaign-item]')
      const shouldDisable = items.length <= 1

      container.querySelectorAll('[data-remove-button]').forEach(button => {
        button.disabled = shouldDisable
        if (shouldDisable) {
          button.classList.add('opacity-50', 'cursor-not-allowed')
        } else {
          button.classList.remove('opacity-50', 'cursor-not-allowed')
        }
      })
    },

    updateIndexes() {
      const container = this.$refs.container
      const items = container.querySelectorAll('[data-campaign-item]')
      items.forEach((item, index) => {
        const header = item.querySelector('h3')
        if (header) {
          const errorSpan = header.querySelector('span')
          if (errorSpan) {
            // エラー表示spanがある場合は保持してテキスト部分のみ更新
            const newText = `キャンペーン ${index + 1}`
            header.firstChild.textContent = newText
          } else {
            header.textContent = `キャンペーン ${index + 1}`
          }
        }

        item.querySelectorAll('input, select, textarea').forEach(input => {
          const name = input.getAttribute('name')
          if (name) {
            input.setAttribute('name', name.replace(/\[\d+\]/, `[${index}]`))
          }
        })
      })
    },

    createCampaignTemplate(index) {
      return `
        <div class="campaign-form-item border border-gray-300 rounded-lg p-6 mb-4" data-campaign-item>
          <div class="flex justify-between items-start mb-4">
            <h3 class="text-lg font-medium text-gray-900">キャンペーン ${index + 1}</h3>
            <button class="btn-danger btn-xs" type="button" @click="removeCampaign" data-remove-button>削除</button>
          </div>

          <div class="space-y-6">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">キャンペーン名</label>
                <input class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                       type="text"
                       name="delivery_campaigns[${index}][name]"
                       placeholder="キャンペーン名を入力">
              </div>

              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">配信タイプ</label>
                <select class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                        name="delivery_campaigns[${index}][delivery_type]">
                  <option value="">配信タイプを選択してください</option>
                  <option value="normal">通常配信</option>
                  <option value="special">スペシャル</option>
                  <option value="initial">初回</option>
                  <option value="follow">フォロー</option>
                </select>
              </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">テンプレート</label>
                <select class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                        name="delivery_campaigns[${index}][delivery_template_id]">
                  <option value="">テンプレートを選択してください</option>
                  ${this.getTemplateOptions()}
                </select>
              </div>

              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">配信グループ</label>
                <select class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                        name="delivery_campaigns[${index}][delivery_group_id]">
                  <option value="">配信グループを選択してください</option>
                  ${this.getGroupOptions()}
                </select>
              </div>
            </div>

            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">説明</label>
              <textarea class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                        name="delivery_campaigns[${index}][description]"
                        rows="4"
                        placeholder="キャンペーンの説明を入力（任意）"></textarea>
            </div>
          </div>
        </div>
      `
    },

    getTemplateOptions() {
      const firstSelect = document.querySelector('select[name*="delivery_template_id"]')
      if (!firstSelect) return ''

      return Array.from(firstSelect.options)
        .filter(opt => opt.value !== '')
        .map(opt => `<option value="${opt.value}">${opt.text}</option>`)
        .join('')
    },

    getGroupOptions() {
      const firstSelect = document.querySelector('select[name*="delivery_group_id"]')
      if (!firstSelect) return ''

      return Array.from(firstSelect.options)
        .filter(opt => opt.value !== '')
        .map(opt => `<option value="${opt.value}">${opt.text}</option>`)
        .join('')
    }
  }
}
